import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import mutations from "./mutations";
import * as institutions from "@/store/modules/institution.js";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem("degree_token"),
        loading: false
    },

    getters: {
        getToken: state => state.token
    },

    modules: {
        institutions
    },

    actions,
    mutations
});
